import { render, staticRenderFns } from "./MemberDetail.vue?vue&type=template&id=f3618e3c&scoped=true&"
import script from "./MemberDetail.vue?vue&type=script&lang=ts&"
export * from "./MemberDetail.vue?vue&type=script&lang=ts&"
import style0 from "./MemberDetail.vue?vue&type=style&index=0&id=f3618e3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3618e3c",
  null
  
)

export default component.exports